
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CONFIG } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class DuoSecurityService {

  constructor(
    private http: HttpClient
  ) { }

  public getDuoHostAndHash (loginInfo) {
    const url = `${CONFIG.apiUrl}/uaa/authorization/2fa/apps/duo?username=${loginInfo.username}&code=${loginInfo.authCode}`;
    return this.http.get(url).pipe(
      catchError(ex => {
 throw ex;
}));
  }
}
